export default {
    "address": "0x2481A834705213a34Cb8d8E5f020f3da2c261d2b",
    "abi": [{
        "inputs": [{
            "internalType": "address",
            "name": "initialOwner",
            "type": "address"
        }, {"internalType": "contract IVault", "name": "_vault", "type": "address"}],
        "stateMutability": "nonpayable",
        "type": "constructor"
    }, {"inputs": [], "name": "BorrowTooMuch", "type": "error"}, {
        "inputs": [],
        "name": "ERC20TransferFailed",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "sender", "type": "address"}, {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
        }, {"internalType": "address", "name": "owner", "type": "address"}],
        "name": "ERC721IncorrectOwner",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "operator", "type": "address"}, {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
        }], "name": "ERC721InsufficientApproval", "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "approver", "type": "address"}],
        "name": "ERC721InvalidApprover",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "operator", "type": "address"}],
        "name": "ERC721InvalidOperator",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "owner", "type": "address"}],
        "name": "ERC721InvalidOwner",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "receiver", "type": "address"}],
        "name": "ERC721InvalidReceiver",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "sender", "type": "address"}],
        "name": "ERC721InvalidSender",
        "type": "error"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "ERC721NonexistentToken",
        "type": "error"
    }, {"inputs": [], "name": "ExceedBorrowAmountMax", "type": "error"}, {
        "inputs": [],
        "name": "ExceedMaxLeverage",
        "type": "error"
    }, {"inputs": [], "name": "InsufficientBorrowReceived", "type": "error"}, {
        "inputs": [],
        "name": "InsufficientCloseReceived",
        "type": "error"
    }, {"inputs": [], "name": "InsufficientReceived", "type": "error"}, {
        "inputs": [],
        "name": "InvalidCallback",
        "type": "error"
    }, {"inputs": [], "name": "InvalidLevel", "type": "error"}, {
        "inputs": [],
        "name": "InvalidReserves",
        "type": "error"
    }, {"inputs": [], "name": "LowFeePoolMarginBanned", "type": "error"}, {
        "inputs": [],
        "name": "MarginBelowMinimum",
        "type": "error"
    }, {"inputs": [], "name": "MirrorTooMuch", "type": "error"}, {
        "inputs": [],
        "name": "MismatchedPoolKey",
        "type": "error"
    }, {"inputs": [], "name": "NativeTransferFailed", "type": "error"}, {
        "inputs": [],
        "name": "NotOwner",
        "type": "error"
    }, {"inputs": [], "name": "NotVault", "type": "error"}, {
        "inputs": [],
        "name": "PositionLiquidated",
        "type": "error"
    }, {"inputs": [], "name": "PositionNotLiquidated", "type": "error"}, {
        "inputs": [],
        "name": "PriceSlippageTooHigh",
        "type": "error"
    }, {"inputs": [], "name": "ReservesNotEnough", "type": "error"}, {
        "inputs": [],
        "name": "SafeCastOverflow",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "token", "type": "address"}],
        "name": "SafeERC20FailedOperation",
        "type": "error"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "owner", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "approved",
            "type": "address"
        }, {"indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "Approval",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "owner", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "operator",
            "type": "address"
        }, {"indexed": false, "internalType": "bool", "name": "approved", "type": "bool"}],
        "name": "ApprovalForAll",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
        }, {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "marginAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "marginTotal", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "debtAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "releaseAmount", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "repayAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "closeAmount", "type": "uint256"}],
        "name": "Close",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
        }, {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "marginAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "marginTotal", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "debtAmount",
            "type": "uint256"
        }, {
            "indexed": false,
            "internalType": "Reserves",
            "name": "truncatedReserves",
            "type": "uint256"
        }, {"indexed": false, "internalType": "Reserves", "name": "pairReserves", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "releaseAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "repayAmount", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "profitAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "lostAmount", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "fundAmount",
            "type": "uint256"
        }],
        "name": "LiquidateBurn",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
        }, {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "marginAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "marginTotal", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "debtAmount",
            "type": "uint256"
        }, {
            "indexed": false,
            "internalType": "Reserves",
            "name": "truncatedReserves",
            "type": "uint256"
        }, {"indexed": false, "internalType": "Reserves", "name": "pairReserves", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "releaseAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "repayAmount", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "needRepayAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "lostAmount", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "fundAmount",
            "type": "uint256"
        }],
        "name": "LiquidateCall",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "address",
            "name": "owner",
            "type": "address"
        }, {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "marginAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "marginTotal", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "debtAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "bool", "name": "marginForOne", "type": "bool"}],
        "name": "Margin",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": false, "internalType": "uint24", "name": "oldFee", "type": "uint24"}, {
            "indexed": false,
            "internalType": "uint24",
            "name": "newFee",
            "type": "uint24"
        }],
        "name": "MarginFeeChanged",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{
            "indexed": false,
            "internalType": "bytes32",
            "name": "oldLevel",
            "type": "bytes32"
        }, {"indexed": false, "internalType": "bytes32", "name": "newLevel", "type": "bytes32"}],
        "name": "MarginLevelChanged",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
        }, {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "marginAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "marginTotal", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "debtAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "int256", "name": "changeAmount", "type": "int256"}],
        "name": "Modify",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "user", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
        }],
        "name": "OwnershipTransferred",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
        }, {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "marginAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "marginTotal", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "debtAmount",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "releaseAmount", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "repayAmount",
            "type": "uint256"
        }],
        "name": "Repay",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "from", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "to",
            "type": "address"
        }, {"indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "Transfer",
        "type": "event"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "Currency",
                "name": "currency0",
                "type": "address"
            }, {"internalType": "Currency", "name": "currency1", "type": "address"}, {
                "internalType": "uint24",
                "name": "fee",
                "type": "uint24"
            }, {"internalType": "uint24", "name": "marginFee", "type": "uint24"}],
            "internalType": "struct PoolKey",
            "name": "key",
            "type": "tuple"
        }, {
            "components": [{"internalType": "bool", "name": "marginForOne", "type": "bool"}, {
                "internalType": "uint24",
                "name": "leverage",
                "type": "uint24"
            }, {"internalType": "uint256", "name": "marginAmount", "type": "uint256"}, {
                "internalType": "uint256",
                "name": "borrowAmount",
                "type": "uint256"
            }, {"internalType": "uint256", "name": "borrowAmountMax", "type": "uint256"}, {
                "internalType": "address",
                "name": "recipient",
                "type": "address"
            }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
            "internalType": "struct IMarginPositionManager.CreateParams",
            "name": "params",
            "type": "tuple"
        }],
        "name": "addMargin",
        "outputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "borrowAmount",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "swapFeeAmount", "type": "uint256"}],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "to", "type": "address"}, {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
        }], "name": "approve", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "owner", "type": "address"}],
        "name": "balanceOf",
        "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "uint24",
            "name": "closeMillionth",
            "type": "uint24"
        }, {"internalType": "uint256", "name": "closeAmountMin", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
        }], "name": "close", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "getApproved",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "getPositionState",
        "outputs": [{
            "components": [{
                "internalType": "bool",
                "name": "marginForOne",
                "type": "bool"
            }, {"internalType": "uint128", "name": "marginAmount", "type": "uint128"}, {
                "internalType": "uint128",
                "name": "marginTotal",
                "type": "uint128"
            }, {
                "internalType": "uint256",
                "name": "depositCumulativeLast",
                "type": "uint256"
            }, {"internalType": "uint128", "name": "debtAmount", "type": "uint128"}, {
                "internalType": "uint256",
                "name": "borrowCumulativeLast",
                "type": "uint256"
            }], "internalType": "struct MarginPosition.State", "name": "position", "type": "tuple"
        }],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "owner", "type": "address"}, {
            "internalType": "address",
            "name": "operator",
            "type": "address"
        }],
        "name": "isApprovedForAll",
        "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
        }],
        "name": "liquidateBurn",
        "outputs": [{"internalType": "uint256", "name": "profit", "type": "uint256"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
        }],
        "name": "liquidateCall",
        "outputs": [{"internalType": "uint256", "name": "profit", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "repayAmount",
            "type": "uint256"
        }],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }, {"internalType": "uint24", "name": "leverage", "type": "uint24"}, {
                "internalType": "uint256",
                "name": "marginAmount",
                "type": "uint256"
            }, {"internalType": "uint256", "name": "borrowAmount", "type": "uint256"}, {
                "internalType": "uint256",
                "name": "borrowAmountMax",
                "type": "uint256"
            }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
            "internalType": "struct IMarginPositionManager.MarginParams",
            "name": "params",
            "type": "tuple"
        }],
        "name": "margin",
        "outputs": [{"internalType": "uint256", "name": "borrowAmount", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "swapFeeAmount",
            "type": "uint256"
        }],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [],
        "name": "marginLevels",
        "outputs": [{"internalType": "MarginLevels", "name": "", "type": "bytes32"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "int128",
            "name": "changeAmount",
            "type": "int128"
        }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
        "name": "modify",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [],
        "name": "name",
        "outputs": [{"internalType": "string", "name": "", "type": "string"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "nextId",
        "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "owner",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "ownerOf",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "poolIds",
        "outputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}],
        "name": "poolKeys",
        "outputs": [{"internalType": "Currency", "name": "currency0", "type": "address"}, {
            "internalType": "Currency",
            "name": "currency1",
            "type": "address"
        }, {"internalType": "uint24", "name": "fee", "type": "uint24"}, {
            "internalType": "uint24",
            "name": "marginFee",
            "type": "uint24"
        }],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "repayAmount",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
        "name": "repay",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "from", "type": "address"}, {
            "internalType": "address",
            "name": "to",
            "type": "address"
        }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "from", "type": "address"}, {
            "internalType": "address",
            "name": "to",
            "type": "address"
        }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "bytes",
            "name": "data",
            "type": "bytes"
        }], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "operator", "type": "address"}, {
            "internalType": "bool",
            "name": "approved",
            "type": "bool"
        }], "name": "setApprovalForAll", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "bytes32", "name": "_marginLevel", "type": "bytes32"}],
        "name": "setMarginLevel",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes4", "name": "interfaceId", "type": "bytes4"}],
        "name": "supportsInterface",
        "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "symbol",
        "outputs": [{"internalType": "string", "name": "", "type": "string"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "tokenURI",
        "outputs": [{"internalType": "string", "name": "", "type": "string"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "from", "type": "address"}, {
            "internalType": "address",
            "name": "to",
            "type": "address"
        }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "transferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "newOwner", "type": "address"}],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes", "name": "data", "type": "bytes"}],
        "name": "unlockCallback",
        "outputs": [{"internalType": "bytes", "name": "", "type": "bytes"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [],
        "name": "vault",
        "outputs": [{"internalType": "contract IVault", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }]
}